/**
 * Resolve a backend upload/media path to an absolute URL the browser can load.
 * Static files are mounted at /api/uploads → /app/uploads.
 * Legacy DB values may still be "/uploads/..." without the /api prefix.
 */
export function resolveUploadUrl(url) {
  if (!url) return null;
  if (
    url.startsWith('http://') ||
    url.startsWith('https://') ||
    url.startsWith('blob:') ||
    url.startsWith('data:')
  ) {
    return url;
  }

  const base = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');
  let path = url.startsWith('/') ? url : `/${url}`;

  // Content/avatars live under the /api/uploads StaticFiles mount
  if (path.startsWith('/uploads/') && !path.startsWith('/api/uploads/')) {
    path = `/api${path}`;
  }

  return `${base}${path}`;
}
